// extracted by mini-css-extract-plugin
export default {"overlay":"IconButton_overlay__HBnK+","button":"IconButton_button__RIdVS","center":"IconButton_center__sUQvI"};